import React from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { SubHeaderLabel } from "../Labels.tsx";

const OtpPasswordUI: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Col md={4} className="d-flex flex-column m-auto">
      <SubHeaderLabel>
        {t("noProject.noProjectsTitle")}
        <br /> {t("noProject.noProjectsDescription")}
      </SubHeaderLabel>
    </Col>
  );
};

export default OtpPasswordUI;
